import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTitle } from "../components/Reveal";
import { CONTACT } from "../data/content";

const IMPRESSUM = [
  {
    h: "Angaben gemäß § 5 DDG",
    p: [
      `${CONTACT.brand} – Inhaber: ${CONTACT.owner}`,
      `${CONTACT.street}, ${CONTACT.city}`,
    ],
  },
  {
    h: "Kontakt",
    p: [`Telefon: ${CONTACT.phoneDisplay}`, "Telefax: 0 27 61 / 6 34 73", `E-Mail: ${CONTACT.email}`],
  },
  {
    h: "Handwerksrolle und Aufsicht",
    p: [
      "Eingetragener Meisterbetrieb des Maler- und Lackiererhandwerks. Zuständige Handwerkskammer: Handwerkskammer Südwestfalen.",
      "Steuer-Nr.: 338/5012/0515",
      "ID-Nr.: 81/564/025/936",
    ],
  },
  {
    h: "Verantwortlich für den Inhalt",
    p: [`${CONTACT.owner}, Anschrift wie oben.`],
  },
  {
    h: "Berufsrechtliche Regelungen",
    p: [
      "Es gelten die Handwerksordnung (HwO) sowie die einschlägigen berufsrechtlichen Regelungen des Maler- und Lackiererhandwerks. Die Handwerksordnung kann auf den Seiten der Handwerkskammer Südwestfalen eingesehen werden.",
    ],
  },
  {
    h: "Verbraucherstreitbeilegung",
    p: [
      "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    ],
  },
  {
    h: "Bildnachweis",
    p: [
      "Die auf dieser Website verwendeten Bilder sind teilweise Originalaufnahmen realer Projekte und unseres Teams (Bereiche Referenzen und Über uns), teilweise mithilfe künstlicher Intelligenz erstellte illustrative Darstellungen bzw. Eigentum des Betriebs (Logo, Wappen, Markenmotive). KI-generierte Szenen, Objekte und Personen sind beispielhafte Visualisierungen und zeigen keine realen Projekte, Kunden oder Personen.",
    ],
  },
  {
    h: "Haftung für Inhalte und Links",
    p: [
      "Alle Inhalte wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Für Inhalte externer Links sind ausschließlich deren Betreiber verantwortlich.",
    ],
  },
];

const DATENSCHUTZ = [
  {
    h: "1. Verantwortlicher",
    p: [
      `${CONTACT.brand} – ${CONTACT.owner}, ${CONTACT.street}, ${CONTACT.city}`,
      `Telefon: ${CONTACT.phoneDisplay}, E-Mail: ${CONTACT.email}`,
    ],
  },
  {
    h: "2. Allgemeines zur Datenverarbeitung",
    p: [
      "Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung dieser Website und zur Bearbeitung Ihrer Anfragen erforderlich ist. Rechtsgrundlagen sind Art. 6 Abs. 1 lit. a, b und f DSGVO.",
      "Diese Website verwendet keine Tracking-Tools, keine Analyse-Dienste und setzt keine Marketing-Cookies.",
      "Einwilligungs-Einstellungen: Beim ersten Besuch können Sie über den Hinweis „Datenschutz-Einstellungen“ entscheiden, ob externe Medien (Google Maps) geladen werden dürfen. Ihre Auswahl wird ausschließlich lokal in Ihrem Browser gespeichert (Local Storage, § 25 Abs. 2 TDDDG) und nicht an uns übertragen. Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen“ im Seitenfuß ändern oder widerrufen.",
      "Alle auf dieser Website verwendeten Schriftarten sind lokal auf unserem Server eingebunden. Eine Verbindung zu Servern von Google (Google Fonts) oder anderen Schriftarten-Anbietern findet beim Aufruf der Website nicht statt.",
    ],
  },
  {
    h: "3. Server-Logfiles",
    p: [
      "Beim Aufruf der Website werden durch den Hosting-Anbieter automatisch technische Zugriffsdaten (z. B. IP-Adresse, Datum und Uhrzeit, Browsertyp) in Logfiles gespeichert. Diese Daten dienen der Sicherstellung eines störungsfreien Betriebs und werden nicht mit anderen Datenquellen zusammengeführt.",
      "Unser Hosting-Anbieter setzt zum Schutz der Website vor automatisierten Angriffen (Bot-Abwehr) ein technisch notwendiges Sicherheits-Cookie. Dieses ist für den sicheren Betrieb erforderlich (§ 25 Abs. 2 TDDDG, Art. 6 Abs. 1 lit. f DSGVO) und wird nicht zu Analyse- oder Werbezwecken verwendet.",
    ],
  },
  {
    h: "4. Kontaktaufnahme",
    p: [
      "Wenn Sie uns über das Kontaktformular oder den KI-Assistenten eine Anfrage senden, werden die eingegebenen Daten (Name, Kontaktdaten, Nachricht) an unseren Server übermittelt, dort zur Bearbeitung gespeichert und zusätzlich per E-Mail an uns weitergeleitet.",
      "Die von Ihnen übermittelten Daten verwenden wir ausschließlich zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO). Eine Weitergabe an Dritte erfolgt nicht. Die Daten werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.",
      "Bewerbungen: Wenn Sie sich über das Bewerbungsformular auf unserer Karriereseite bewerben, verarbeiten wir die von Ihnen angegebenen Daten (Name, Kontaktdaten, Wunschposition, Nachricht) ausschließlich zur Durchführung des Bewerbungsverfahrens (Art. 6 Abs. 1 lit. b DSGVO, § 26 BDSG). Ihre Bewerbungsdaten werden spätestens sechs Monate nach Abschluss des Verfahrens gelöscht, sofern keine Einstellung erfolgt und Sie keiner längeren Aufbewahrung zugestimmt haben.",
    ],
  },
  {
    h: "5. KI-Assistent (Chatbot)",
    p: [
      "Auf dieser Website können Sie über einen KI-Assistenten Fragen zu unseren Leistungen stellen. Ihre Eingaben werden zur Beantwortung an einen Anbieter künstlicher Intelligenz (OpenAI) übermittelt und dort verarbeitet; dabei kann eine Übermittlung in Drittländer (insbesondere die USA) nicht ausgeschlossen werden. Der Verlauf Ihres Gesprächs wird zur Fortsetzung des Dialogs gespeichert.",
      "Bitte geben Sie im Chat keine sensiblen personenbezogenen Daten ein. Rechtsgrundlage ist Ihre freiwillige Nutzung des Angebots (Art. 6 Abs. 1 lit. a und f DSGVO). Gespeicherte Gesprächsverläufe werden regelmäßig gelöscht (spätestens nach 90 Tagen).",
      "Zur Fortsetzung Ihres Gesprächs wird eine zufällig erzeugte Sitzungs-Kennung im lokalen Speicher Ihres Browsers (Local Storage) abgelegt. Diese Kennung ist für die Funktion des Chats technisch erforderlich (§ 25 Abs. 2 TDDDG), enthält keine personenbezogenen Daten und wird nicht zu Analyse- oder Werbezwecken verwendet.",
    ],
  },
  {
    h: "6. E-Mail-Versand (Resend)",
    p: [
      "Für den Versand von Anfragen und Terminbestätigungen nutzen wir den E-Mail-Dienstleister Resend (Resend Inc., USA). Dabei werden die von Ihnen übermittelten Inhalte (Name, Kontaktdaten, Nachricht) zur Zustellung über die Server des Anbieters verarbeitet.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Bearbeitung Ihrer Anfrage). Mit dem Anbieter besteht eine Auftragsverarbeitung; eine Übermittlung in die USA erfolgt auf Grundlage von Standardvertragsklauseln.",
    ],
  },
  {
    h: "7. Regionaldaten (Wetter und Veranstaltungen)",
    p: [
      "Für die Anzeige aktueller Wetterdaten und Veranstaltungen der Region werden Anfragen an externe Dienste (Open-Meteo für Wetterdaten) gesendet. Diese Anfragen enthalten keine personenbezogenen Daten von Ihnen; lediglich die technisch notwendige IP-Verbindung zum jeweiligen Dienst entsteht.",
    ],
  },
  {
    h: "8. Google Maps (Zwei-Klick-Einbindung)",
    p: [
      "Diese Website bindet Google Maps erst nach Ihrem aktiven Klick auf „Karte laden“ ein. Erst mit diesem Klick wird eine Verbindung zu den Servern von Google hergestellt und dabei Ihre IP-Adresse sowie ggf. weitere Daten an Google (Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irland) übertragen.",
      "Die Einbindung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ohne Ihren Klick findet keine Datenübertragung an Google statt. Details entnehmen Sie der Datenschutzerklärung von Google.",
    ],
  },
  {
    h: "9. Ihre Rechte",
    p: [
      "Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten personenbezogenen Daten (Art. 15 DSGVO), auf Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch gegen die Verarbeitung (Art. 21).",
      "Zudem haben Sie das Recht, sich bei der zuständigen Aufsichtsbehörde (Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen) zu beschweren.",
    ],
  },
  {
    h: "10. Aktualität",
    p: [
      "Stand: September 2026. Diese Datenschutzerklärung wird angepasst, sobald Änderungen der Website dies erforderlich machen.",
    ],
  },
];

const AGB = [
  {
    h: "§ 1 Geltungsbereich",
    p: [
      `Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über Maler- und Lackiererarbeiten sowie damit zusammenhängende Leistungen zwischen ${CONTACT.brand} (nachfolgend „Auftragnehmer") und dem Auftraggeber.`,
      "Für Bauleistungen gelten ergänzend die Verdingungsordnung für Bauleistungen Teil B (VOB/B), soweit nichts Abweichendes vereinbart ist. Abweichende Bedingungen des Auftraggebers erkennen wir nur an, wenn wir ihnen ausdrücklich schriftlich zugestimmt haben.",
    ],
  },
  {
    h: "§ 2 Angebot und Vertragsschluss",
    p: [
      "Unsere Angebote sind freibleibend, sofern sie nicht ausdrücklich als verbindlich gekennzeichnet sind. Maßgeblich ist der Inhalt der schriftlichen Auftragsbestätigung. Ein Vertrag kommt mit unserer schriftlichen Auftragsbestätigung oder mit Beginn der Ausführung zustande.",
      "An Kostenvoranschlägen, Zeichnungen und sonstigen Unterlagen behalten wir uns das Eigentum und Urheberrecht vor; sie dürfen Dritten nicht ohne unsere Zustimmung zugänglich gemacht werden.",
    ],
  },
  {
    h: "§ 3 Ausführung der Leistungen",
    p: [
      "Wir führen alle Arbeiten nach den anerkannten Regeln des Handwerks, fachgerecht und mit geeigneten Materialien aus. Farb- und Materialabweichungen, die herstellungs- oder materialbedingt sind, bleiben vorbehalten, soweit sie im handelsüblichen Rahmen liegen.",
      "Nachträgliche Änderungs- oder Zusatzwünsche des Auftraggebers bedürfen der schriftlichen Vereinbarung und werden gesondert berechnet.",
    ],
  },
  {
    h: "§ 4 Mitwirkungspflichten des Auftraggebers",
    p: [
      "Der Auftraggeber stellt sicher, dass die Baustelle bzw. die Arbeitsräume rechtzeitig zugänglich, frei und arbeitsfähig sind. Erforderliche Nebenleistungen wie Strom, Wasser und geeignete Lagerflächen werden vom Auftraggeber unentgeltlich bereitgestellt, sofern nichts anderes vereinbart ist.",
      "Schäden, die durch vom Auftraggeber nicht oder nicht rechtzeitig gemeldete Mängel der Bausubstanz (z. B. Feuchtigkeit, Risse, Altbeschichtungen) entstehen, gehen nicht zu unseren Lasten.",
    ],
  },
  {
    h: "§ 5 Preise und Zahlung",
    p: [
      "Es gelten die im Angebot bzw. in der Auftragsbestätigung vereinbarten Preise zzgl. der gesetzlichen Umsatzsteuer. Rechnungen sind ohne Abzug innerhalb von 14 Tagen nach Rechnungszugang fällig, sofern nichts Abweichendes vereinbart ist.",
      "Abschlagszahlungen können entsprechend dem Baufortschritt vereinbart werden. Bei Zahlungsverzug werden Verzugszinsen in gesetzlicher Höhe berechnet. Aufrechnung und Zurückbehaltung sind nur mit unbestrittenen oder rechtskräftig festgestellten Forderungen zulässig.",
    ],
  },
  {
    h: "§ 6 Termine, Fristen und Verzögerungen",
    p: [
      "Ausführungstermine und -fristen sind nur verbindlich, wenn sie ausdrücklich schriftlich als verbindlich vereinbart wurden. Witterungsbedingte Verzögerungen (z. B. Frost, Nässe bei Fassadenarbeiten) sowie behördliche oder vom Auftraggeber zu vertretende Verzögerungen verlängern vereinbarte Fristen angemessen.",
    ],
  },
  {
    h: "§ 7 Abnahme",
    p: [
      "Der Auftraggeber ist zur Abnahme der Leistung verpflichtet, sobald ihm die Fertigstellung angezeigt wurde. Die Abnahme gilt als erfolgt, wenn der Auftraggeber die Leistung in Gebrauch nimmt oder die Abnahme trotz angemessener Fristsetzung nicht erklärt.",
    ],
  },
  {
    h: "§ 8 Gewährleistung",
    p: [
      "Für Mängel an Bauleistungen leisten wir Gewähr nach den Vorschriften der VOB/B (§ 13); die Verjährungsfrist beträgt vier Jahre. Für sonstige Werkleistungen gelten die gesetzlichen Bestimmungen des BGB.",
      "Offensichtliche Mängel sind unverzüglich, spätestens jedoch innerhalb von zwei Wochen nach Abnahme schriftlich anzuzeigen.",
    ],
  },
  {
    h: "§ 9 Haftung",
    p: [
      "Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden aus der Verletzung von Leben, Körper oder Gesundheit. Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt. Im Übrigen ist die Haftung ausgeschlossen.",
    ],
  },
  {
    h: "§ 10 Eigentumsvorbehalt",
    p: [
      "Gelieferte Materialien bleiben bis zur vollständigen Bezahlung unser Eigentum. Verarbeitete Materialien an Bauwerken gehen insoweit mit den gesetzlichen Regelungen konform, als ein Vorbehalt nach den gesetzlichen Bestimmungen zulässig ist.",
    ],
  },
  {
    h: "§ 11 Schlussbestimmungen",
    p: [
      "Es gilt das Recht der Bundesrepublik Deutschland. Erfüllungsort und – soweit gesetzlich zulässig vereinbar – Gerichtsstand ist Olpe. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
      "Stand: September 2026.",
    ],
  },
];

export const LegalPage = ({ kind }) => {
  const TITLES = { impressum: "Impressum", datenschutz: "Datenschutzerklärung", agb: "Allgemeine Geschäftsbedingungen" };
  const SECTIONS = { impressum: IMPRESSUM, datenschutz: DATENSCHUTZ, agb: AGB };
  const title = TITLES[kind] || TITLES.impressum;
  useTitle(`${title} – Manfred Berglar · Malermeister seit 1925`);
  const sections = SECTIONS[kind] || IMPRESSUM;
  return (
    <div className="min-h-screen bg-white text-ink">
      <header className="border-b border-line">
        <div className="container-x h-[84px] flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-sm font-semibold hover:text-golddark transition-colors duration-300 py-3"
          >
            <ArrowLeft size={16} /> Zurück zur Startseite
          </Link>
          <img src="/images/logo-komposition.png" alt="Manfred Berglar – Malermeister seit 1925" className="h-12 w-auto" />
        </div>
      </header>
      <main className="container-x py-16 md:py-24">
        <div className="max-w-3xl">
          <p className="kicker">Rechtliches</p>
          <h1 data-testid="legal-title" className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-12 break-words hyphens-auto">
            {title}
          </h1>
          {sections.map((s) => (
            <section key={s.h} className="mb-10 border-t border-line pt-8">
              <h2 className="font-display text-2xl font-semibold tracking-tight mb-4">{s.h}</h2>
              {s.p.map((t, i) => (
                <p key={i} className="text-muted leading-relaxed mb-3">
                  {t}
                </p>
              ))}
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};
